import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject, map } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PeopleSyncService {

  url = environment.API_URL; // API URL from environment file
  localUrl = "http://localhost:3000"; // Local API URL for testing

  constructor(private _http: HttpClient) { }

  // Get all people from the API
  getAllPeople() {
    return this._http.get(this.url + '/people').pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get all people from the API with a specific name
  getPeopleByName(name: string) {
    return this._http.get(this.url + '/people/name/' + name).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get people by exact name
  getPeopleByExactName(name: string) {
    return this._http.get(this.url + '/people/exact/' + name).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get people by title
  getPeopleByTitle(title: string) {
    return this._http.get(this.url + '/people/title/' + title).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get people by Organization
  getPeopleByOrganization(organization: string) {
    return this._http.get(this.url + '/people/organization/' + organization).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get people by Business Function
  getPeopleByBusinessFunction(businessFunction: string) {
    return this._http.get(this.url + '/people/business_function/' + businessFunction).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get people by city
  getPeopleByCity(city: string) {
    return this._http.get(this.url + '/people/city/' + city).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get people by state
  getPeopleByState(state: string) {
    return this._http.get(this.url + '/people/state/' + state).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get people by country
  getPeopleByCountry(country: string) {
    return this._http.get(this.url + '/people/country/' + country).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  //Manager
  //Under

  // Get people by GMID
  getPeopleByGMID(gmid: string) {
    return this._http.get(this.url + '/people/gmid/' + gmid).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get people by email
  getPeopleByEmail(email: string) {
    console.log("Needs to encode @ symbol in email address");
    // return this._http.get(this.url + '/people/email/' + email).pipe(
    //   map((res: any) => {
    //     return res;
    //   })
    // );
  }

  // Get people by GMIN
  getPeopleByGMIN(gmin: string) {
    return this._http.get(this.url + '/people/gmin/' + gmin).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get tracking updates
  getUpdateTracking() {
    return this._http.get(this.url + '/admin/update_tracking').pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  // Get error tracking
  getErrorTracking() {
    return this._http.get(this.url + '/admin/errors').pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getErrors() {
    return this._http.get(this.url + '/admin/errors').pipe(
      map((res: any) => {
        return res;
      })
    );
  }
}
